import script from "./SocialShare.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialShare.vue?vue&type=script&setup=true&lang=js"

import "./SocialShare.vue?vue&type=style&index=0&id=38e08818&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e08818"]])

export default __exports__